export const usePasskeyLoginFlow = createSharedComposable(() => {
    const { webauthn } = useCoreConfig()
    const { canLoginWithWebPasskey, registrationState, passkeyLoginSucceeded, initiatePassKeyLogin: initiateWebPasskeyLogin } = useWebauthn()
    const { isMobileApp } = useMobileApp()
    const { appPasskeyState, initiatePassKeyLogin: initiateMobilePasskeyLogin } = useMobileAppPasskeys()

    async function attemptPasskeyThenNavigate({ navigateOnDismiss = true } = {}) {
        await initiateMobilePasskeyLogin()
        // On success the page is already reloading; navigating now would render
        // the logged-in state for a frame before the reload completes.
        if (passkeyLoginSucceeded.value) return
        const hasError = !!registrationState.value.error
        if (hasError || navigateOnDismiss) {
            await navigateTo({ query: { auth: 'login', ...(hasError ? { passkey_error: '1' } : {}) } })
        }
    }

    async function handleLoginClick() {
        if (webauthn?.enabled) {
            if (isMobileApp && appPasskeyState.value === 'CREATED') {
                return await attemptPasskeyThenNavigate()
            }

            if (!isMobileApp && import.meta.client && canLoginWithWebPasskey.value) {
                await initiateWebPasskeyLogin()
                if (passkeyLoginSucceeded.value) return
                await navigateTo({ query: { auth: 'login', ...(registrationState.value.error ? { passkey_error: '1' } : {}) } })
                return
            }
        }

        await navigateTo({ query: { auth: 'login' } })
    }

    return { handleLoginClick }
})
